module.exports = __webpack_public_path__ + "media/images/dog-9bfbf8c6c48b8afe4f59ebf9e673c7d5.svg";